import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase from "../../lib/firebase";
import ar from "../../locale";
import Loading from "../../lib/Loading";
import { title } from "../../constants";
import PhotoUploader from "../../lib/PhotoUploader";

export default class SlideshowAdd extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      loading: false,
    };
    this.slideshowRef = firebase.database().ref("slideshow/");
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.slideshow;
    this.updateState();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  saveAvatar = async (croppedImage) => {
    this.state.croppedImage = croppedImage;
  };

  /**
   * Fetch image from state and save
   */
  uploadAvatar = (key) => {
    return firebase
      .storage()
      .ref("slideshow/" + key)
      .put(this.state.croppedImage);
  };

  updateSlideDetails = () => {
    let title = this.title.value;
    let subtitle = this.subtitle.value;
    let content = this.content.value;
    if (this.state.croppedImage) {
      if (title && subtitle && content) {
        this.showLoading(true);
        let slideshowKey = this.messageIdGenerator();
        this.slideshowRef
          .child(slideshowKey)
          .set({
            key: slideshowKey,
            title: title,
            subtitle: subtitle,
            content: content,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          })
          .then(() => this.uploadAvatar(slideshowKey))
          .then((snapshot) => snapshot.ref.getDownloadURL())
          .then((downloadURL) =>
            this.slideshowRef.child(slideshowKey).update({ image: downloadURL })
          )
          .then(() => {
            this.showLoading(false);
            this.showSuccess(ar.operation_successful);
            this.props.history.replace("/slideshow");
          })
          .catch((error) => {
            this.showLoading(false);
            this.showError(error.message);
          });
      } else {
        this.showError(ar.enter_valid_details);
      }
    } else {
      this.showError(ar.upload_logo_here);
    }
  };

  /**
   * Generates a new message id for the firebase chat
   */
  messageIdGenerator = () => {
    return this.slideshowRef.push().key;
  };

  render() {
    let { loading } = this.state;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <h2 className="card-title">{ar.slideshow}</h2>
                  <h5 className="card-subtitle mb-0">
                    {ar.enter_valid_details}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <PhotoUploader
                onSaveAvatar={this.saveAvatar}
                onlyaspectratio={true}
                aspect={6 / 2}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="inputname"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.title}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.title = e)}
                      className="form-control"
                      id="inputname"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="inputsubt"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.subtitle}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.subtitle = e)}
                      className="form-control"
                      id="inputsubt"
                    />
                  </div>
                  <div className="mt-5 mb-3 font-weight-bold">
                    <p>
                      <span className="text-danger ml-1">*</span>
                      {ar.enter_description}
                    </p>
                  </div>
                  <div id="quill-editor" className="min-h200">
                    <textarea
                      ref={(e) => (this.content = e)}
                      className="form-control"
                      rows={10}
                    ></textarea>
                  </div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-rounded btn-info"
                      onClick={this.updateSlideDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loading show={loading} />
      </div>
    );
  }
}
